import { render, staticRenderFns } from "./ContentTemplate.vue?vue&type=template&id=11c82222&scoped=true&"
import script from "./ContentTemplate.vue?vue&type=script&lang=js&"
export * from "./ContentTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ContentTemplate.vue?vue&type=style&index=0&id=11c82222&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c82222",
  null
  
)

export default component.exports